import { createTheme } from '@mui/material/styles';
import { overrides } from './theme/overrides';
import { palette } from './theme/palette';
import { typography } from './theme/typography';

const theme = createTheme({
  palette,
  typography,
  }
);

theme.components = overrides(theme);


export default theme;
